import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import "./globals.scss";
import "./index.css";
import "./font.css";
import "./layout.css";
import { HelmetProvider } from "react-helmet-async";

import Home from "./component/home";
import Contact from "./component/contact";
import Activities from "./component/activities";
import Gallery from "./component/gallery";
import Mandatory from "./component/mandatory";
import Admission from "./component/admission";
import About from "./component/about";
import VisionMission from "./component/visionmission";
import Facilities from "./component/facilities";
import ScholasticProgram from "./component/scholaticProgram";
import CoScholasticProgram from "./component/coScholastic";
import Career from "./component/career";
import OtherDocument from "./component/otherDocument";
import SchoolDetails from "./component/schoolDetails";
import AverageSchoolDay from "./component/averageschoolday";
import Leader from "./component/leadership";
import ActivityDetails from "./component/activity-details";
import RefundPolicy from "./component/refundPolicy";
import PrivacyPolicy from "./component/privacyPolicy";
import Terms from "./component/terms";

function App() {
  return (
    <HelmetProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route
          path="/mandatory-public-disclosure"
          element={<Mandatory />}
        />
        <Route path="/admission" element={<Admission />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/vision-mission" element={<VisionMission />} />
        <Route path="/facilities" element={<Facilities />} />
        <Route
          path="/scholastic-program"
          element={<ScholasticProgram />}
        />
        <Route
          path="/co-scholastic-program"
          element={<CoScholasticProgram />}
        />
        <Route path="/career" element={<Career />} />
        <Route path="/other-document" element={<OtherDocument />} />
        <Route path="/school-details" element={<SchoolDetails />} />
        <Route
          path="/average-school-day"
          element={<AverageSchoolDay />}
        />
        <Route path="/leadership" element={<Leader />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/terms-and-conditions"
          element={<Terms />}
        />
        <Route
          path="/activities/:id"
          element={<ActivityDetails />}
        />
      </Routes>
    </HelmetProvider>
  );
}

export default App;